import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubscriptionQueryService } from '~app/farp-odq/store/subscription/subscription-query.service';
import { SelectedPremiumInfo, SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';

@Component({
    selector: 'odq-surplus',
    templateUrl: './surplus.component.html',
    styleUrls: ['./surplus.component.scss', '../styles/subscription-forms.css'],
    standalone: false
})
export class SurplusComponent  {
  @Input() model: SubscriptionFormViewModel;
  @Input() selectedPremium: SelectedPremiumInfo;
  @Input() inactiveMemberForSubscription: boolean;
  @Output() onUserDecidedSurplus = new EventEmitter<boolean>();

  constructor(private queryService: SubscriptionQueryService) {

  }

   onUserRefuseSurplus(value: boolean) {
     this.selectedPremium.surplusId = null;    
     this.setSelectedPremiumValues();
  }

  onUserSelectedSurplus() {
    this.selectedPremium.userRefuseSurplus = false;
    this.setSelectedPremiumValues();
  }

  hasMemberSuprime() {
    return this.model?.surplus?.some(s=>s.calcSubprime>0);
  }

  hasMemberCredit() {
    return this.model?.credit<0;
  }

  isMobileMode(): boolean {
    return this.queryService.isMobile();
  }

  setSelectedPremiumValues() { 
    this.selectedPremium.calculateTotals(this.model);
    this.selectedPremium.resetPaymentInfo();
    this.onUserDecidedSurplus.emit(true);
  }
}